var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('b-icon',{attrs:{"icon":"calendar"}}),_c('div',{staticClass:"position-absolute year-count"},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }